import axios from 'axios';

// API Keys
const NEWS_API_KEY = "1a890964719d486c9daef74ced1e1f19";
const EXCHANGE_API_KEY = "cf5b280cdc104285432a67cd";
const FINNHUB_API_KEY = 'cu6uofhr01qh2ki6jrigcu6uofhr01qh2ki6jrj0';

// Fetch Stock Data
export const fetchStockData = async (symbol) => {
  try {
    const response = await axios.get(
      `https://finnhub.io/api/v1/quote?symbol=${symbol}&token=${FINNHUB_API_KEY}`
    );
    console.log('API Response for ' + symbol + ':', response.data);  // Log the full response

    const data = response.data;
    if (data && data.c !== null) {
      return {
        symbol,
        price: data.c || 'N/A',
        open: data.o || 'N/A',
        high: data.h || 'N/A',
        low: data.l || 'N/A',
        volume: data.v || 'N/A',
        currency: 'USD',
      };
    } else {
      console.error('No stock data found for the provided symbol.');
      return null;
    }
  } catch (error) {
    console.error('Error fetching stock data:', error.response || error.message || error);
    return null;
  }
};



// Fetch Financial Data (Balance Sheet, Income Statement, Cash Flow)
export const fetchFinancialData = async (symbol) => {
  try {
    const balanceSheetResponse = await axios.get(
      `https://finnhub.io/api/v1/stock/financials?symbol=${symbol}&statement=BS&token=${FINNHUB_API_KEY}`
    );
    const incomeStatementResponse = await axios.get(
      `https://finnhub.io/api/v1/stock/financials?symbol=${symbol}&statement=IS&token=${FINNHUB_API_KEY}`
    );
    const cashFlowResponse = await axios.get(
      `https://finnhub.io/api/v1/stock/financials?symbol=${symbol}&statement=CF&token=${FINNHUB_API_KEY}`
    );

    return {
      balanceSheet: balanceSheetResponse.data,
      incomeStatement: incomeStatementResponse.data,
      cashFlow: cashFlowResponse.data,
    };
  } catch (error) {
    console.error("Error fetching financial data:", error);
    return null;
  }
};

// Fetch Market News
export const fetchMarketNews = async () => {
  try {
    const response = await axios.get(
      `https://newsapi.org/v2/everything?q=stocks&apiKey=${NEWS_API_KEY}`
    );
    return response.data.articles;
  } catch (error) {
    console.error("Error fetching market news:", error);
    throw error;
  }
};

// Fetch Currency Exchange Rates
export const fetchCurrencyRates = async () => {
  try {
    const response = await axios.get(
      `https://v6.exchangerate-api.com/v6/${EXCHANGE_API_KEY}/latest/USD`
    );
    return response.data.conversion_rates;
  } catch (error) {
    console.error("Error fetching currency rates:", error);
    throw error;
  }
};
